<div class="bar" [class.disabled]="disabled()">
  <div
    class="indicator"
    [class]="color()"
    [class.overflow]="value() > max()"
    [style.width.%]="(value() / max()) * 100"
  ></div>
</div>
